import PropTypes from 'prop-types';

const withTableProps = {
  data: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.shape()]),
  totalCount: PropTypes.number,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  filtering: PropTypes.shape({}),
  filterOptions: PropTypes.shape({}),
  isFetchingTableData: PropTypes.bool,
  handleChangePage: PropTypes.func,
  handleSorting: PropTypes.func,
  handleForceUpdate: PropTypes.func,
  handleRemoveFilter: PropTypes.func,
  handleClearFilters: PropTypes.func,
  handleFiltering: PropTypes.func,
  handleChangeFetchMethod: PropTypes.func,
  getRequestParams: PropTypes.func,
};

export default withTableProps;
